/**
 * @generated SignedSource<<ff910494fe1b52b5d66a04f72de72a11>>
 * @relayHash 53f97b473c25d54b1e881d0ef17c1b83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 213ef46475f31ba317ecb99db320f2fb2c32c37da8423f1b74d62a084a1b6a86

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalBrandingQuery } from './GlobalBrandingQuery.graphql';

const node: PreloadableConcreteRequest<GlobalBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "213ef46475f31ba317ecb99db320f2fb2c32c37da8423f1b74d62a084a1b6a86",
    "metadata": {},
    "name": "GlobalBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
